import React from "react";
import { Box, Tooltip } from "@mui/material";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import { AgentProducerCode } from "../../interfaces/DTO/agent/agentProducerCode";

// נרמול קוד סוכן להשוואה: ללא אפסים מובילים, "_" כמו "-" (למשל מיטב: 2_8644 = 2-8644)
const normalizeAgentCode = (code: string): string => code.trim().replace(/_/g, "-").replace(/^0+/, "");

export const isKnownAgentCode = (agentCode: string, handlerCode: string | undefined, agentProducerCodes: AgentProducerCode[]): boolean => {
  const normalized = normalizeAgentCode(agentCode);
  return agentProducerCodes.some(
    (a) => a.handler_code === handlerCode && normalizeAgentCode(a.code ?? "") === normalized
  );
};

// קוד הסוכן מוגדר ביצרן כקוד REV&U (shared_with_rev)
export const isRevAgentCode = (agentCode: string, handlerCode: string | undefined, agentProducerCodes: AgentProducerCode[]): boolean => {
  const normalized = normalizeAgentCode(agentCode);
  return agentProducerCodes.some(
    (a) => a.shared_with_rev === true && a.handler_code === handlerCode && normalizeAgentCode(a.code ?? "") === normalized
  );
};

// עיגול כתום עם PersonOffIcon – קוד סוכן שאינו מוגדר בקודי הסוכן של היצרן
// עיגול אפור עם PersonOffIcon – קוד הסוכן מסומן כמיועד להפסקת פעילות (for_deactivation)
export const ForDeactivationIcon: React.FC<{ size?: number; title?: string }> = ({ size = 28, title }) => {
  const icon = (
    <Box
      sx={{
        width: size,
        height: size,
        minWidth: size,
        borderRadius: "50%",
        backgroundColor: "#bdbdbd",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <PersonOffIcon sx={{ fontSize: Math.round(size * 0.7) }} />
    </Box>
  );
  // ה-Tooltip עוטף את ה-Box ישירות – על Fragment הוא לא נפתח
  return title ? <Tooltip title={title}>{icon}</Tooltip> : icon;
};

export const AgentNotFoundIcon: React.FC = () => (
  <Tooltip title="קוד הסוכן אינו מוגדר בקודי הסוכן של היצרן">
    <Box
      sx={{
        width: 20,
        height: 20,
        borderRadius: "50%",
        backgroundColor: "orange",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <PersonOffIcon sx={{ fontSize: 14 }} />
    </Box>
  </Tooltip>
);

interface Props {
  agentCode?: string | null;
  handlerCode?: string;
  agentProducerCodes: AgentProducerCode[];
}

// תא "סוכן בפוליסה" – אייקון כתום כשקוד הסוכן אינו מוגדר בקודי הסוכן של היצרן
const MimshakAgentCodeCell: React.FC<Props> = ({ agentCode, handlerCode, agentProducerCodes }) => {
  if (!agentCode) return null;
  const isKnown = isKnownAgentCode(agentCode, handlerCode, agentProducerCodes);

  return (
    <Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", gap: 0.75 }}>
      <span>{agentCode}</span>
      {!isKnown && <AgentNotFoundIcon />}
    </Box>
  );
};

export default MimshakAgentCodeCell;
